import React, { useEffect, ComponentType, FC } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

// Higher-order component for tracking page views that works with lazy-loaded components
const withTracker = <P extends object>(
  WrappedComponent: ComponentType<P>
): FC<P> => {
  const WithTrackerComponent: FC<P> = (props: P) => {
    const location = useLocation();
    
    useEffect(() => {
      // Track pageview on location change
      const page = location.pathname + location.search;
      // Ensure ReactGA is initialized before sending
      if (ReactGA.isInitialized) {
        ReactGA.send({
          hitType: "pageview",
          page,
          title: document.title,
        });
      }
    }, [location]);

    return <WrappedComponent {...props} />;
  };

  // Set display name for debugging
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithTrackerComponent.displayName = `withTracker(${displayName})`;

  return WithTrackerComponent;
};

export default withTracker; 